import { render, staticRenderFns } from "./DownloadBadges.vue?vue&type=template&id=47c6f11f"
import script from "./DownloadBadges.vue?vue&type=script&lang=js"
export * from "./DownloadBadges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports